import PropTypes from 'prop-types';
import type * as React from 'react';
import Button from '../../Button';
import LinkButton from '../../LinkButton';
import styles from './style.m.less';

interface Props {
    icon?: React.ReactNode;
    title: React.ReactNode;
    href?: string;
    openInModal?: boolean;
    onButtonClick?: () => void;
    buttonLabel?: React.ReactNode;
    children: React.ReactNode;
}

export default function PopupAlertContent({
    icon,
    title,
    href,
    openInModal,
    onButtonClick,
    buttonLabel,
    children,
}: Props) {
    return (
        <section className={styles.outerFlexRow}>
            {icon && <div className={styles.icon}>{icon}</div>}
            <div className={styles.content}>
                <h1 className={styles.title}>{title}</h1>
                {children}
            </div>
            <div className={styles.info}>
                {href ? (
                    <LinkButton isSmall href={href} openInModal={openInModal} className={styles.button}>
                        {buttonLabel || 'View'}
                    </LinkButton>
                ) : null}
                {onButtonClick ? (
                    <Button isSmall onClick={onButtonClick} className={styles.button}>
                        {buttonLabel || 'View'}
                    </Button>
                ) : null}
            </div>
        </section>
    );
}

PopupAlertContent.propTypes = {
    icon: PropTypes.node,
    title: PropTypes.node.isRequired,
    buttonLabel: PropTypes.string,
    href: PropTypes.string,
    onButtonClick: PropTypes.func,
    children: PropTypes.node.isRequired,
};
